export function encodeFormData(formElement: HTMLFormElement): string {
  const formData = new FormData(formElement);
  const plainFormData = Object.fromEntries(formData.entries());
  const params = new URLSearchParams(plainFormData as Record<string, string>);
  return params.toString();
}
